import cogoToast from 'cogo-toast';
import { isMobile } from '@common/utils/responsive';

const DELACON_WIDGET_BUTTON = 'delacon-widget';
const formClass = 'form-flow';
const waitlistModalId = 'waitlist-modal';
const activeWaitlistMode = document.querySelector(
  `#${waitlistModalId} .${formClass}__mode--active`,
);

const toggleDisplayStyle = (element, displayValue) => {
  const el = element;
  if (el) {
    el.style.display = displayValue;
  }
};

function showCallUs() {
  const target = document.querySelector(
    `.${DELACON_WIDGET_BUTTON}__item--desktop`,
  );
  target?.setAttribute('data-target', 'delacon-number-modal');
}

function initialize() {
  const widgetButton = document.getElementById(
    DELACON_WIDGET_BUTTON,
  );

  const phoneWidget = document.getElementById('phone-widget');
  const chatWidget = document.getElementById('chat-widget');
  const widgetIcon = document.getElementById('widget-icon');
  const widgetClose = document.getElementById('widget-close');
  const callWidget = document.querySelector('.delacon-widget__item--mobile');
  const modalWidget = document.querySelector('.delacon-widget__item--desktop');
  const bookCounsellingBtn = document.querySelector('.banner__counselling-cta');
  const parentFormEl = document.querySelector('.form-flow__modes');
  const copyBtnEl = document.querySelector('.delacon-number-modal__copy-btn');
  const delaconNumber = document
    .querySelector('.delacon-number-modal__phone-number').textContent;

  if (isMobile()) {
    callWidget?.classList.remove('hidden');
    modalWidget?.classList.add('hidden');
  } else {
    callWidget?.classList.add('hidden');
    modalWidget?.classList.remove('hidden');
  }

  if (!activeWaitlistMode) {
    showCallUs();
  }

  const closeRequestCallbackContainer = () => {
    toggleDisplayStyle(phoneWidget, 'none');
    toggleDisplayStyle(chatWidget, 'none');
    toggleDisplayStyle(widgetIcon, '');
    toggleDisplayStyle(widgetClose, 'none');
  };

  chatWidget?.addEventListener('click', (event) => {
    event.stopPropagation();
    bookCounsellingBtn.click();
    parentFormEl?.setAttribute(
      'data-success-action', 'book_counselling');
  });

  phoneWidget?.addEventListener('click', (event) => {
    event.stopPropagation();
  });

  modalWidget?.addEventListener('click', (event) => {
    event.stopPropagation();
    parentFormEl?.setAttribute(
      'data-success-action', 'call_us_directly');
  });

  widgetButton?.addEventListener('click', (event) => {
    event.stopPropagation();
    if (widgetIcon.style.display === 'none') {
      closeRequestCallbackContainer();
    } else {
      toggleDisplayStyle(phoneWidget, 'flex');
      toggleDisplayStyle(chatWidget, 'flex');
      toggleDisplayStyle(widgetIcon, 'none');
      toggleDisplayStyle(widgetClose, '');
    }
  });

  copyBtnEl?.addEventListener('click', () => {
    navigator.clipboard.writeText(delaconNumber);
    cogoToast.success('Copied to Clipboard');
  });
}

export default { showCallUs, initialize };
